import { JsonRpcModule } from '../../jrpc/module';

export class SceneModule extends JsonRpcModule {
  async loadScene(sceneName: string): Promise<void> {
    return this.channel.call('Scene.LoadScene', [sceneName]);
  }

  async initializeAR(): Promise<void> {
    return this.channel.call('Scene.InitializeAR', []);
  }

  async deinitializeAR(): Promise<void> {
    return this.channel.call('Scene.DeinitializeAR', []);
  }
}
